import packageJson from "../../package.json";

export const POS_FRONTEND_BUILD_MARKER = "po-receipt-fix-2026-03-10-r2";

export const POS_FRONTEND_BUILD_INFO = {
  version: packageJson.version,
  marker: POS_FRONTEND_BUILD_MARKER,
};
